import { connect } from 'react-redux';
import AreaFilter from './area-filter';
import {
  loadAreas,
  setFilterOption,
} from '../../../reducers/filter.reducers';


const mapStateToProps = state => ({
  areas: state.filter.areas,
  selectedAreas: state.filter.filterOptions.areaId,
  selectedLocation: state.reports.selectedLocation,
});

const mapDispatchToProps = dispatch => ({
  loadAreas: locationId => dispatch(loadAreas(locationId)),
  setFilterOption: filterOption => dispatch(setFilterOption(filterOption)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AreaFilter);
